import { ReactNode } from 'react';

interface CvLayoutProps {
  children: ReactNode;
}

export default function CvLayout({ children }: CvLayoutProps) {
  return (
    <div className="min-h-screen text-white p-8 md:p-20 font-sans print:p-0 print:min-h-0 print:bg-white">
      <div className="max-w-4xl mx-auto relative bg-[rgba(30,60,74,0.3)] rounded-xl border border-[rgba(120,136,255,0.15)] backdrop-blur-sm p-8 md:p-12 shadow-[0_0_25px_rgba(100,136,255,0.25)] print:bg-white print:border-0 print:shadow-none print:p-0 print:rounded-none">
        <div className="absolute inset-0 rounded-xl overflow-hidden print:hidden">
          <div className="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg width=\'6\' height=\'6\' viewBox=\'0 0 6 6\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'%23FFFFFF\' fill-opacity=\'0.05\' fill-rule=\'evenodd\'%3E%3Cpath d=\'M5 0h1L0 6V5zM6 5v1H5z\'/%3E%3C/g%3E%3C/svg%3E')] opacity-30"></div>
        </div>
        
        <div className="relative z-10 print:bg-white">
          {children}
        </div>
      </div>
      <div className="hidden print:block print:fixed print:inset-0 print:bg-white print:-z-10"></div>
    </div>
  );
} 